module.exports = __webpack_public_path__ + "static/media/background.7da653d9.png";